import React from 'react'
import SelectInput from './SelectInput'

// An "add" picker: choosing an option fires onAdd immediately and the control resets to its label
// (it holds no value). A thin, semantic wrapper over SelectInput so every "Lägg till …" picker
// looks and behaves the same, and future select restyling stays in one place. autoSelectSingle is
// off: a lone remaining option must not auto-add itself without the user choosing it.
export default function AddSelect<Value extends string | number, Option>(
    { label, options, valueGetter, nameGetter, onAdd, sx }: {
        label: string,
        options: Option[],
        valueGetter: (option: Option) => Value,
        nameGetter: (option: Option) => string,
        onAdd: (value: Value) => void,
        sx?: {},
    }) {
    return <SelectInput label={label} required={false} autoSelectSingle={false} sx={sx}
        options={options} valueGetter={valueGetter} nameGetter={nameGetter}
        value={null} onChange={onAdd}/>
}
